import React, { useState } from 'react';
import StatusIndicator from './StatusIndicator';

const GameLobby = ({ onCreateGame, onJoinGame, connectionStatus }) => {
  const [gameId, setGameId] = useState('');
  const [showJoinForm, setShowJoinForm] = useState(false);

  const handleCreateGame = () => {
    onCreateGame();
  };

  const handleJoinGame = (e) => {
    e.preventDefault();
    if (gameId.trim()) {
      onJoinGame(gameId.trim());
    }
  };



  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">🃏 Last Card</h1>
          <p className="text-gray-400 mb-4">Real-time 1v1 Card Game</p>
          
          {/* Connection Status */}
          <div className="flex items-center justify-center mb-6">
            <StatusIndicator status={connectionStatus} />
          </div>
        </div>

        {/* Game Options */}
        <div className="bg-gray-800 rounded-xl p-6 shadow-2xl">
          <h2 className="text-2xl font-semibold text-white mb-6 text-center">
            Start a Game
          </h2>

          {/* Create Game */}
          <div className="mb-6">
            <button
              onClick={handleCreateGame}
              disabled={false} // Allow clicking even when disconnected - connection will be established
              className="w-full btn btn-primary text-lg py-4"
            >
              🎮 Create New Game
            </button>
            <p className="text-gray-400 text-sm mt-2 text-center">
              Create a new game and share the code with a friend
            </p>
          </div>

          {/* Divider */}
          <div className="flex items-center mb-6">
            <div className="flex-1 border-t border-gray-600"></div>
            <span className="px-4 text-gray-400 text-sm">OR</span>
            <div className="flex-1 border-t border-gray-600"></div>
          </div>

          {/* Join Game */}
          <div>
            {!showJoinForm ? (
              <button
                onClick={() => setShowJoinForm(true)}
                disabled={false} // Allow clicking even when disconnected - connection will be established
                className="w-full btn btn-secondary text-lg py-4"
              >
                🔗 Join Existing Game
              </button>
            ) : (
              <form onSubmit={handleJoinGame} className="space-y-4">
                <div>
                  <label htmlFor="gameId" className="block text-sm font-medium text-gray-300 mb-2">
                    Game Code
                  </label>
                  <input
                    type="text"
                    id="gameId"
                    value={gameId}
                    onChange={(e) => setGameId(e.target.value)}
                    placeholder="Enter game code..."
                    className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    required
                  />
                </div>
                
                <div className="flex space-x-3">
                  <button
                    type="submit"
                    disabled={!gameId.trim()} // Only disable if no game ID entered
                    className="flex-1 btn btn-success"
                  >
                    Join Game
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setShowJoinForm(false);
                      setGameId('');
                    }}
                    className="flex-1 btn btn-secondary"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            )}
            
            {showJoinForm && (
              <p className="text-gray-400 text-sm mt-2 text-center">
                Enter the game code shared by your friend
              </p>
            )}
          </div>
        </div>

        {/* Game Rules */}
        <div className="mt-8 bg-gray-800 rounded-xl p-6">
          <h3 className="text-lg font-semibold text-white mb-4">🎯 How to Play</h3>
          <div className="space-y-2 text-sm text-gray-300">
            <p>• Match suit or rank to play cards</p>
            <p>• <strong>2:</strong> Next player draws 2 cards</p>
            <p>• <strong>7:</strong> Skip next player</p>
            <p>• <strong>8:</strong> Reverse (same player goes again)</p>
            <p>• <strong>J:</strong> Wild card - choose suit</p>
            <p>• <strong>🃏 Joker:</strong> Next player draws 5 and skips</p>
            <p>• Call "Last Card" before your final move!</p>
            <p>• Start with 5 cards each</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameLobby; 